module.exports = __webpack_public_path__ + "img/c0b5cc7467c6bc83eec15fb4183c7fe7.b1ffe9c3.png";